import http from '@/libs/http'

/**
 * 获取用户角色
 */
export const getUserRoles = () => {
  return http({
    url: '/s/index/getUserRoles',
    method: 'get'
  })
}
